var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.92492 10.575C1.69159 10.3417 1.69159 9.99167 1.92492 9.75833C2.15825 9.525 2.50825 9.525 2.74159 9.75833L6.41658 13.4333V0.833333C6.41658 0.483333 6.64992 0.25 6.99992 0.25C7.34992 0.25 7.58325 0.483333 7.58325 0.833333V13.4333L11.2583 9.75833C11.4916 9.525 11.8416 9.525 12.0749 9.75833C12.3083 9.99167 12.3083 10.3417 12.0749 10.575L7.40825 15.2417C7.34992 15.3 7.29158 15.3583 7.23325 15.3583C7.17492 15.4167 7.05825 15.4167 6.99992 15.4167C6.94159 15.4167 6.82492 15.4167 6.76659 15.3583C6.70825 15.3 6.64992 15.3 6.59159 15.2417L1.92492 10.575ZM12.8333 14.25C12.4833 14.25 12.2499 14.4833 12.2499 14.8333V16.5833H1.74992V14.8333C1.74992 14.4833 1.51659 14.25 1.16659 14.25C0.816585 14.25 0.583252 14.4833 0.583252 14.8333V17.1667C0.583252 17.5167 0.816585 17.75 1.16659 17.75H12.8333C13.1833 17.75 13.4166 17.5167 13.4166 17.1667V14.8333C13.4166 14.4833 13.1833 14.25 12.8333 14.25Z",
    fill: "#A3A3A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.679fc9debb48e632650de6b9ad1591c3.svg";
export { ForwardRef as ReactComponent };